import { createContext } from 'react';
export const chameleonPrefixContext = createContext(undefined);
export const ChameleonPrefixProvider = chameleonPrefixContext.Provider;
